//@ts-check
import React from 'react';
import { Typography, withStyles, createStyles } from '@material-ui/core';
var styles = createStyles({
  error: {
    color: '#f10000'
  }
});
/**
 * @param {import('./types').GridViewErrorProps & import('@material-ui/core').WithStyles<typeof styles>} props
 */

var GridViewError = function GridViewError(_ref) {
  var _ref$error = _ref.error,
      error = _ref$error.error,
      text = _ref$error.text,
      classes = _ref.classes;
  return React.createElement("span", null, React.createElement(Typography, {
    className: classes.error
  }, 'Error: ' + error, text && ' (' + text + ')'));
};

GridViewError.defaultProps = {
  error: {
    error: 'Unknown'
  }
};
export default withStyles(styles, {
  name: 'ECGridViewError'
})(GridViewError);